import React from 'react'
import { render } from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import configureStore from 'redux/store'
import { configureTranslation } from 'i18n'
import { serviceRouter } from 'routes'
import { ApolloClient } from 'apollo-client'
import { ApolloProvider } from 'react-apollo'
import { ApolloLink } from 'apollo-link'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { createHttpLink } from 'apollo-link-http'
import { createGraphqlInterface } from 'frontend_core/dist/api/graphql'
import Cookie from 'js-cookie'
import 'react-hot-loader/patch'
import ErrorPage from 'containers/pages/ErrorPage'
// import { hot } from 'react-hot-loader'

import RestProvider from 'frontend_core/dist/api/rest/provider'
import RestClient, {
  createRestInterface,
} from 'frontend_core/dist/api/rest/client'

window.i18n = configureTranslation(__SPM_TRANSLATION__)
delete window.__SPM_TRANSLATION__

window.manifest = __SPM_MANIFEST__
delete window.__SPM_MANIFEST__

const preloadedState = window.__SPM_PRELOADED_STATE__
delete window.__SPM_PRELOADED_STATE__

const errorStatus = window.__SPM_ERROR_STATUS__
delete window.__SPM_ERROR_STATUS__

// server side rendering flag turns off
preloadedState.config.SSR = false
const config = preloadedState.config
const httpLink = createHttpLink({
  uri: `${config.SPM_GRAPHQL_API_HOST}/graphql`,
})
const apiHeaders = createGraphqlInterface({ config }).headers

if (typeof window !== 'undefined') {
  import('amplitude-js').then(amplitude => {
    // Amplitude初期化
    const amp = amplitude.default || amplitude
    amp.getInstance().init(config.AMPLITUDE_API_KEY)
  })
}

const middlewareLink = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: apiHeaders,
  })
  return forward(operation)
})
const link = middlewareLink.concat(httpLink)

const apolloClient = new ApolloClient({
  link: link,
  cache: new InMemoryCache().restore(window.__SPM_APOLLO_STATE__),
})
const store = configureStore(preloadedState)
const AppRoute = serviceRouter('account', config.SSR, errorStatus)

const restInterface = createRestInterface({ config })
const restClient = new RestClient(restInterface)

const isProduction = config.ENV === 'production'
if (isProduction) {
  Sentry.init({ dsn: config.SENTRY_DSN })
}

const renderApp = () => (
  <RestProvider client={restClient}>
    <ApolloProvider client={apolloClient}>
      <Provider store={store}>
        {!!errorStatus ? (
          <ErrorPage status={errorStatus} />
        ) : (
          <BrowserRouter>
            <AppRoute />
          </BrowserRouter>
        )}
      </Provider>
    </ApolloProvider>
  </RestProvider>
)
const root = document.getElementById('js-root')
render(renderApp(), root)
